"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var UploadCloudCircleFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_UploadCloudCircleFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16ZM3.798 6.045a3.501 3.501 0 0 1 5.718-1.64 2.253 2.253 0 0 1 2.756 1.656 2.25 2.25 0 0 1-.522 4.439H10a.5.5 0 0 1 0-1h1.75a1.25 1.25 0 0 0 .23-2.479.833.833 0 0 1-.668-.668 1.25 1.25 0 0 0-1.596-.965.833.833 0 0 1-.821-.194A2.501 2.501 0 0 0 4.74 6.393a.833.833 0 0 1-.683.621A1.25 1.25 0 0 0 4.25 9.5H6a.5.5 0 0 1 0 1H4.25a2.25 2.25 0 0 1-.452-4.455Zm3.848-.398a.498.498 0 0 1 .709 0 .507.507 0 0 1 .02.022l1.98 1.977a.5.5 0 0 1-.707.708L8.5 7.207V12a.5.5 0 1 1-1 0V7.208L6.353 8.354a.5.5 0 1 1-.706-.707l1.981-1.982a.505.505 0 0 1 .018-.018Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_UploadCloudCircleFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = UploadCloudCircleFill;
exports["default"] = _default;